@if (componentData.data$ | async; as component) {
  <boels-vertical-aligner
    class="boels-cards__container"
    [ngClass]="{
      'background--dark': component.backgroundColor === backgroundColor.GREY,
      'pb-0': component.removeBottomSpacing | safeCheck,
    }"
  >
    @if (component.title) {
      <h2 class="boels-cards__heading">{{ component.title }}</h2>
    }

    @if (cards$ | async; as data) {
      <div
        class="boels-cards__cards-wrapper"
        [ngClass]="'-columns-' + data.length"
      >
        @for (dataItem of data; track dataItem) {
          <boels-card [cardComponentData]="dataItem"></boels-card>
        }
      </div>
    }
  </boels-vertical-aligner>
}
